import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  computed,
  contentChild,
  input,
  TemplateRef,
} from '@angular/core';
import { Popover } from "primeng/popover";

@Component({
  selector: 'app-detail-row',
  imports: [NgTemplateOutlet, Popover],
  templateUrl: './detail-row.component.html',
  styleUrl: './detail-row.component.css',
})
export class DetailRowComponent {
  editor = contentChild<TemplateRef<unknown>>('editor');
  help = contentChild<TemplateRef<unknown>>('help');
  label = input('');
  editMode = input(false);

  space = computed(() => {
    if (this.editMode() && !this.editor()) {
      return 'spacer';
    }
    return '';
  });
}
